import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, FileWarning, SearchX } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <FileWarning className="h-6 w-6 text-red-500" data-id="element-186" />,
    text: 'Client requirements live in messy call notes and emails.'
  }, {
    icon: <XCircle className="h-6 w-6 text-orange-500" data-id="element-187" />,
    text: 'Manually writing SOWs and test plans costs hours per project.'
  }, {
    icon: <SearchX className="h-6 w-6 text-slate-500" data-id="element-188" />,
    text: 'No single source of truth across systems, documents, and audit history.'
  }];
  return <section className="py-20 bg-slate-50 border-y border-slate-200" data-id="element-189">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-190">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-191">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-192">
            <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-193">
              The problem with manual ERP project management.
            </h2>
            <p className="text-lg text-slate-600" data-id="element-194">
              Consultancies lose billable hours and risk scope creep by managing
              complex implementations in spreadsheets and docs.
            </p>
          </motion.div>

          <div className="space-y-6" data-id="element-195">
            {problems.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start gap-4 p-4 bg-white rounded-lg border border-slate-200 shadow-sm" data-id="element-196">
                <div className="shrink-0 mt-1 bg-slate-50 p-2 rounded-full" data-id="element-197">
                  {item.icon}
                </div>
                <p className="text-slate-700 font-medium pt-1" data-id="element-198">{item.text}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}